var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6817 3.28594C16.5472 -0.761981 9.84406 -0.761981 5.70965 3.28594L5.16352 3.82066C4.9568 4.02306 4.9568 4.35121 5.16352 4.5536L6.86564 6.22013C6.969 6.32133 7.13658 6.32133 7.23994 6.22013L7.97323 5.50217C10.8574 2.67824 15.5338 2.67824 18.4181 5.50217L19.1029 6.17258C19.2062 6.27378 19.3738 6.27378 19.4771 6.17258L21.1792 4.50606C21.3859 4.30366 21.3859 3.97551 21.1792 3.77312L20.6817 3.28594ZM25.7167 8.21571L24.2019 6.73249C23.9951 6.5301 23.6599 6.5301 23.4532 6.73249L18.6051 11.4792C18.5535 11.5298 18.4697 11.5298 18.418 11.4792L13.5699 6.7324V6.73239C13.3632 6.53 13.0279 6.53001 12.8212 6.73241L7.97336 11.4792C7.92168 11.5298 7.83789 11.5298 7.78621 11.4792L2.93807 6.73241C2.73136 6.53001 2.3962 6.53001 2.18947 6.73241L0.674571 8.21563C0.467851 8.41802 0.467851 8.74617 0.674571 8.94856L7.50554 15.6367C7.71226 15.839 8.04742 15.839 8.25415 15.6367L13.1021 10.8899C13.1538 10.8394 13.2376 10.8394 13.2892 10.8899L18.1373 15.6367C18.344 15.839 18.6793 15.839 18.8859 15.6367L25.7167 8.94865C25.9234 8.74625 25.9234 8.41811 25.7167 8.21571Z",
    fill: "#3B99FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.5e5f599588d10116da93ddc2d89bc7d1.svg";
export { ForwardRef as ReactComponent };